import Illustration from '../../../components/ui/Illustration';
import illuDocument from '../../../assets/illustrations/fonctionnalites/document.svg?raw';
import illuMultiDocs from '../../../assets/illustrations/fonctionnalites/multi-docs.svg?raw';
import illuGenerationIa from '../../../assets/illustrations/fonctionnalites/generation-ia.svg?raw';
import illuCreationManuelle from '../../../assets/illustrations/fonctionnalites/creation-manuelle.svg?raw';
import illuImportJson from '../../../assets/illustrations/fonctionnalites/import-json.svg?raw';

// Pictogrammes dessinés (docs/img/fonctionnalites-gestion-qcm-svg, 27/10/2026), au violet foncé de la marque.
const ILLU_COLOR = '#6d28d9';
import AiQuotaPill from '../../../components/ui/AiQuotaPill';
import BuyPackButton from '../../../components/custom/BuyPackButton';

// Cartes « Source du contenu » + encart descriptif de la source choisie (avec crédits IA).
// En enrichissement : document/multi-doc/ai-prompt seulement (empty et json-import n'ont pas de sens).
export default function SourceSelector({ createMode, setCreateMode, enrichmentTarget, isAdmin, quota, aiQuota, thematiqueId }) {
    const sources = [
        { k: 'document', label: 'Depuis un document' },
        { k: 'multi-doc', label: 'Compilation multi-docs' },
        { k: 'ai-prompt', label: 'Génération IA' },
        ...(!enrichmentTarget ? [{ k: 'empty', label: 'Sujet vide' }] : []),
        ...(!enrichmentTarget && isAdmin ? [{ k: 'json-import', label: 'Import JSON' }] : []),
    ];

    const SRC_ILLU = { document: illuDocument, 'multi-doc': illuMultiDocs, 'ai-prompt': illuGenerationIa, empty: illuCreationManuelle, 'json-import': illuImportJson };
    const isIA = createMode === 'document' || createMode === 'ai-prompt' || createMode === 'multi-doc';
    const desc = {
        document: enrichmentTarget
            ? <>Le document sera <strong>ajouté au sujet existant</strong>. Compte pour <strong>1 génération IA</strong>.</>
            : <><strong>Depuis un document</strong> — l'IA analyse ton fichier (PDF, DOCX, TXT…) et génère 10 à 50 questions. Compte pour <strong>1 génération IA</strong>.</>,
        'multi-doc': enrichmentTarget
            ? <>Plusieurs documents seront <strong>ajoutés au sujet existant</strong> (1 sujet agrégé). Compte pour <strong>1 génération IA</strong>.</>
            : <><strong>Compilation multi-docs</strong> — plusieurs documents agrégés en un seul sujet ; l'IA génère des questions transversales. Compte pour <strong>1 génération IA</strong>.</>,
        'ai-prompt': enrichmentTarget
            ? <>Décris les questions supplémentaires à générer ; elles seront <strong>ajoutées au sujet existant</strong>. Compte pour <strong>1 génération IA</strong>.</>
            : <><strong>Génération IA</strong> — décris le thème et le style ; l'IA s'appuie sur ses connaissances pour générer les questions. Compte pour <strong>1 génération IA</strong>.</>,
        empty: <><strong>Sujet vide</strong> — crée un sujet vide et ajoute tes questions manuellement. Aucune génération IA.</>,
        'json-import': <><strong>Import JSON</strong> — importe un fichier JSON de questions (réservé admin). Aucune génération IA.</>,
    }[createMode];

    return (
        <>
            <div className="ms-sources">
                <div className="ms-sources__label">Source du contenu</div>
                <div className={`ms-sources__grid ms-sources__grid--${sources.length}`}>
                    {sources.map(({ k, label }) => (
                        <button type="button" key={k} className={`ms-source ${createMode === k ? 'is-active' : ''}`} onClick={() => setCreateMode(k)}>
                            <span className="ms-source__icon ms-source__icon--illu"><Illustration svg={SRC_ILLU[k]} color={ILLU_COLOR} /></span>
                            <span className="ms-source__label">{label}</span>
                        </button>
                    ))}
                </div>
            </div>

            <div className="ms-source-desc">
                <span className="ms-source-desc__icon ms-source-desc__icon--illu"><Illustration svg={SRC_ILLU[createMode] || illuDocument} color={ILLU_COLOR} /></span>
                <div className="ms-source-desc__txt">{desc}</div>
                {isIA && quota && (() => {
                    const used = quota.used_ai_generations ?? quota.used_sous_sujets;
                    const limit = quota.max_ai_generations ?? quota.max_sous_sujets;
                    return (
                        <div className="ms-source-desc__credits">
                            <AiQuotaPill
                                quota={{ used, limit, remaining: Math.max(0, limit - used), exceeded: used >= limit, enabled: true }}
                                bypass={aiQuota.bypass}
                                label="Générations IA"
                            />
                            <BuyPackButton thematiqueId={thematiqueId} onPurchased={() => aiQuota.reload()} compact />
                        </div>
                    );
                })()}
            </div>
        </>
    );
}
